import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  getConversations(campaignId) {
    return axios.get(`${this.url}/${campaignId}/conversations`);
  }
}

export default new CampaignsAPI();
